/* eslint-disable no-unused-vars */

import React from "react";
import PropTypes from "prop-types";
import { Grid, Image } from "semantic-ui-react";
import ReactAdsense from "react-adsense";

const Image336x280 = (
  <Image
    centered
    style={{ width: 336, height: 280, backgroundColor: "#f1f1f1" }}
  />
);
const Image728x90 = (
  <Image
    centered
    style={{ width: 728, height: 90, backgroundColor: "#f1f1f1" }}
  />
);
const Image728x180 = (
  <Image
    centered
    style={{ width: "80%", height: 200, backgroundColor: "#f1f1f1" }}
  />
);

const Adsense336x280 = (
  <ReactAdsense.Google
    client="ca-pub-8593060854263123"
    slot="5885286618"
    style={{ display: "inline-block", width: 336, height: 280 }}
  />
);

const AdsenseAuto = (
  <ReactAdsense.Google
    client="ca-pub-8593060854263123"
    slot="1644796883"
    style={{ display: "block" }}
    layout="in-article"
    format="fluid"
  />
);

const AdsenseArticle = (
  <ReactAdsense.Google
    client="ca-pub-8593060854263123"
    slot="6076858305"
    style={{ display: "block", textAlign: "center" }}
    layout="in-article"
    format="fluid"
  />
);

const Adsense = ({ type }, { isMobile }) => {
  if (process.env.NODE_ENV === "development") {
    if (type === "728x90") {
      if (isMobile) {
        return Image336x280;
      }
      return Image728x90;
    }

    if (type === "article") {
      return Image728x180;
    }

    return (
      <Grid columns="2" divided stackable>
        <Grid.Column>{Image336x280}</Grid.Column>
        <Grid.Column>{Image336x280}</Grid.Column>
      </Grid>
    );
  }

  if (type === "article") {
    return AdsenseArticle;
  }

  if (type === "728x90") {
    return AdsenseAuto;
  }
  return (
    <Grid columns="2" divided stackable>
      <Grid.Column>{Adsense336x280}</Grid.Column>
      <Grid.Column>{Adsense336x280}</Grid.Column>
    </Grid>
  );
};

Adsense.contextTypes = {
  isMobile: PropTypes.bool,
};

export default Adsense;
